import React from 'react';
import Orders from '../../Orders/Orders';

const DashboardHome = () => {
    return (
        <div>
            <Orders></Orders>
        </div>
    );
};

export default DashboardHome;